function i(e,o){let t;return function(...u){clearTimeout(t),t=setTimeout(()=>e.apply(this,u),o)}}export{i as debounce};
